// constants
import { REIM_VERIFICATION_CONFIG_CODES } from "constants/global";

// types
import { ConfigDataItem } from "services/api/types";

export function allowApproveOrReject(config: ConfigDataItem[]) {
	const currentDate = new Date().getDate();

	const startDate = config?.find((_config: ConfigDataItem) => _config?.config_dtl_code === REIM_VERIFICATION_CONFIG_CODES.START_DATE)?.config_dtl_val3;
	const endDate = config?.find((_config: ConfigDataItem) => _config?.config_dtl_code === REIM_VERIFICATION_CONFIG_CODES.END_DATE)?.config_dtl_val3;

	if (!startDate || !endDate) {
		return false;
	}

	if (currentDate >= Number(startDate) && currentDate <= Number(endDate)) {
		return true;
	}

	return false;
}

export const getAttachmentsList = (documentString: string) => {
	return documentString?.split("|")?.filter((v) => v);
};
